const trainingOption1Bundle = [
  {
    link: "https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/77170/",
    name: "Gold Star Mini Madness K to 2nd",
    date: "9:15AM to 10:30AM",
  },
]
const trainingOption2Bundle = [
  {
    link: "https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/77171/",
    name: "Gold Star Not So Mini 3rd to 4th",
    date: "10:30AM to 12:00PM",
  },
]

const why =[
  "100% of our profits will be donated towards Gold Star Families",
  "Travel-club quality training, without the travel club lifestyle.",
  "your child gets the same caliber of coaching and skill development you’d find at any travel club. The difference is that it all happens one day a week. There are no weekend road trips, hotel bills, or schedules that take over your family’s life.",
  "We believe great coaching shouldn’t be reserved for families who can afford high club fees. Our programs are built so that cost isn’t the barrier to a kid getting a real chance to grow.",
  "606 Academy is a nonprofit led by a veteran, a minority partner, and a woman partner. Our leadership reflects the families we serve, and our mission is to give kids access, confidence, and a strong foundation, not just a place on a roster.",
  "The bottom line: professional-quality training, a fair price, one day a week, from a team that’s invested in your child and your community.",
  
  ]
  
  const goldstar = [
    "A Gold Star family is a family who has lost a loved one that died while serving in the U.S. armed forces",
    "Parents, spouses, children, and siblings of a fallen service member",
    "A Gold Star family carries a lifelong loss. The star marks the cost of service paid by the family as well as the service member."
  ]

const trainingInfo = [
  "Bring a basketball and a water bottle.",
  "Designed for all Skill Levels",
  "There are 6 baskets in the gym and athletes will be divided by skill level"
]

const trainingDrills = [
  "Triple Threat",
  "Stationary Ball Handling",
  "Ball Handling",
  "Attacking the Basket",
  "Layups",
  "Form Shooting",
  "Footwork",
  "Transition",
  "Three Man Weave",
  "Passing",
  "Passing Off the Dribble",
  "Defense",
  "Rebounding",
  "and more!"
]



export {trainingDrills, trainingInfo,trainingOption1Bundle,trainingOption2Bundle, why, goldstar}